import {IconButton, Stack, styled, Typography} from "@mui/material";
import * as React from "react";
import {useContext, useMemo, useState} from "react";
import {FeedbackContext, FeedbackType} from "../../../context/UserFeedback";
import {updateLoadouts} from "../../../api/user/UpdateUser";
import {Delete, Favorite, FavoriteBorder, Star, StarBorder} from "@mui/icons-material";
import {UserContext} from "../../../context/UserContext";
import {likeLoadout, unlikeLoadout} from "../../../api/user/LoadoutActions";
import {UserProfileContext} from "../ProfilePage";


const LikesPanel = ({loadout, isOwnProfile}) => {
    const {user, setUser} = useContext(UserContext)
    const {userProfile, setUserProfile} = useContext(UserProfileContext)
    const {triggerFeedback} = useContext(FeedbackContext)

    const [liking, setLiking] = useState(false)

    const likes = loadout.likes?.count ?? 0

    const userLiked = useMemo(() => user != null && user.likedLoadouts.includes(loadout.id), [user?.id, user?.likedLoadouts])

    const handleLike = () => {
        if (user == null) return triggerFeedback(`Only logged in users can like loadouts. Stay tuned to @XDLoadout on twitter for the public release or to get your access code!`, FeedbackType.INFO)
        if (isOwnProfile) return triggerFeedback(`Cringe, you can't like your own loadout...`, FeedbackType.INFO)
        if (liking) return
        setLiking(true)
        return (userLiked ? unlikeLoadout(loadout.id) : likeLoadout(loadout.id))
            .then(response => {
                const updatedProfile = {...userProfile}
                updatedProfile.loadouts.find(l => l.id === loadout.id).likes = response.likes
                setUserProfile(updatedProfile)
                setUser({...user, likedLoadouts: userLiked ? user.likedLoadouts.filter(id => id !== loadout.id) : [...user.likedLoadouts, loadout.id]})
            })
            .catch((e) => {
                triggerFeedback(`Failed to ${userLiked ? 'un' : ''}like loadout. Please report this to @XDLoadout on twitter. ):`, FeedbackType.ERROR)
            }).finally(() => setLiking(false))
    }

    return <Stack direction='row' alignItems='center'
                  sx={{p: '3px 8px', borderRadius: '3px', backgroundColor: '#0000004D'}}>
        <Typography sx={{color: 'white', pb: '0px'}}>{likes}</Typography>
        <IconButton sx={{p: 0, ml: '8px'}} onClick={() => handleLike()}>
            {user == null || isOwnProfile || userLiked ? <Favorite sx={{color: user == null || isOwnProfile ? 'white' : 'red', fontSize: '1rem'}}/>
                : <FavoriteBorder sx={{color: 'white', fontSize: '1rem'}}/>}
        </IconButton>
    </Stack>
}

LikesPanel.propTypes = {};
const LoadoutMenu = ({loadout, hideButtons, isOwnProfile}) => {
    const {user, setUser} = useContext(UserContext)
    let hidden = hideButtons ?? []
    return (
        <Stack>
            {isOwnProfile ? <Stack direction='row' sx={{position: 'absolute', right: '10px', top: '10px'}}>
                {hidden.includes('favourite') ? null :
                    <FavouriteButton user={user} setUser={setUser} loadout={loadout}/>}
                {hidden.includes('delete') ? null : <DeleteButton user={user} setUser={setUser} loadout={loadout}/>}
            </Stack> : null}
            <Stack direction='row' sx={{position: 'absolute', left: '10px', top: '10px'}}>
                <LikesPanel loadout={loadout} isOwnProfile={isOwnProfile}/>
            </Stack>
        </Stack>
    )
}

const UserIconButton = styled(IconButton)({
    padding: '3px',
    '&:hover': {
        filter: 'drop-shadow(0px 0px 6px rgb(200 200 200))',
        background: 'none'
    }
})

const DeleteButton = ({user, loadout, setUser}) => {
    const {triggerFeedback} = useContext(FeedbackContext)
    return (
        <UserIconButton onClick={() => {
            updateLoadouts([{...loadout, public: false}])
                .then(u => {
                    setUser({...u, icon: user.icon});
                    triggerFeedback('Loadout removed from profile!', FeedbackType.SUCCESS)
                })
                .catch(() => triggerFeedback('Failed to remove loadout from profile. Please report this to @XDLoadout on twitter. ):', FeedbackType.ERROR))
        }}>
            <Delete sx={{color: 'white'}}/>
        </UserIconButton>
    )
}

const FavouriteButton = ({user, loadout, setUser}) => {
    const {triggerFeedback} = useContext(FeedbackContext)
    return (
        <UserIconButton onClick={() => {
            if (!loadout.favourite && user.loadouts.filter(l => l.favourite) > 4) {
                triggerFeedback('You can only have 5 favourite loadouts.', FeedbackType.ERROR)
                return
            }
            loadout.favourite = !loadout.favourite
            updateLoadouts([loadout])
                .then(u => {
                    setUser({...u, icon: user.icon});
                    triggerFeedback(`Loadout ${loadout.favourite ? '' : 'un'}favourited!`, FeedbackType.SUCCESS)
                })
                .catch(() => triggerFeedback(`Failed to ${loadout.favourite ? 'add' : 'remove'} loadout to favourites. Please report this to @XDLoadout on twitter. ):`, FeedbackType.ERROR))
        }}>
            {loadout.favourite ? <Star sx={{color: 'gold'}}/> : <StarBorder sx={{color: 'white'}}/>}
        </UserIconButton>
    )
}

export default LoadoutMenu